import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAirplayaudioComponent } from './simple-icons-airplayaudio.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAirplayaudioComponent ],
    exports:      [ SimpleIconsAirplayaudioComponent ],
    bootstrap:    []
})
export class SimpleIconsAirplayaudioModule {}
